﻿<div class="container padding-top-lg report-container">

    <app-back-nav class="mb-20" [linkText]="'REPORT.BACK_TO_ASSESSMENTS' | translate"></app-back-nav>
    
    <mat-card *ngIf="isError" class="card-light error-panel">
        <mat-card-title>{{ 'REPORT.ERROR' | translate }}</mat-card-title>
        <mat-card-content>
            {{ errorMessage }}<br>
            {{ 'REPORT.ASSESSMENT_NOT_AVAILABLE' | translate }}
        </mat-card-content>
    </mat-card>

    <app-report-frame 
        class="sub-bk-light"
        [reportTypeName]="data.isContractor ? ('REPORT.CONTRACTOR_REPORT' | translate) : ('REPORT.INDIVIDUAL_REPORT' | translate)"
        [noContentCss]="true"
        [headerRatio21]="true"
        [reportOptions]="reportOptions"
        [legend]="legend"
        [showLegend]="true"
        [showLegendIcon]="false"
        *ngIf="data$ | async as data">
        <ng-container slot="table">

            <div class="content">
                       
                <ng-container *ngFor="let questionSet of data.questionSets">
                    <!-- body -->
                    <ng-container *ngFor="let module of questionSet.childQuestionSets">
    
                        <div class="row module-row" *ngIf="module.childQuestionSets.length > 0">
                                <div class="main-table">                                
                                    <div class="t-body">
                                        
                                        <div *ngFor="let questionGroup of module.childQuestionSets; let groupIndex = index" [ngClass]="{'break-inside-avoid': groupIndex === 0}">
                                            
                                            <ng-container *ngIf="groupIndex === 0">
                                                <div class="module-title">
                                                    {{ module.name.toUpperCase() }}
                                                </div>
            
                                                <app-legend-card [items]="module.ratingBands"></app-legend-card>
                                            </ng-container>

                                            <mat-card class="card-table break-inside-avoid" >
                                                <!-- question group -->
                                                <mat-card-header>
                                                    <div class="t-row font-semibold">
                                                        <div class="t-h mobile-flex-full q-group-name">{{ questionGroup.name }}</div>
                                                        <div class="t-h">{{ 'REPORT.SELF_ASSESSMENT' | translate }}</div>
                                                        <div class="t-h">
                                                            <span *ngIf="data.leaders[0] && data.leaders[0].name">
                                                                {{data.leaders[0]?.name}}<br>
                                                                {{ data.leaders[0]?.employeeIdentifier }}
                                                            </span>
                                                            <span *ngIf="!data.leaders[0] || !data.leaders[0].name">{{ 'REPORT.LEADER_1' | translate }}</span>
                                                        </div>
                                                        <div class="t-h" *ngIf="data.leaders[1]">
                                                            <span *ngIf="data.leaders[1].name">
                                                                {{ data.leaders[1]?.name }}<br>
                                                                {{ data.leaders[1]?.employeeIdentifier }}
                                                            </span>
                                                            <span *ngIf="!data.leaders[1].name">{{ 'REPORT.LEADER_2' | translate }}</span>
                                                        </div>

                                                        <div class="t-h" *ngIf="!state.config.c.reports.separatePeerAndSubordinate">{{ 'REPORT.THREE_SIXTY' | translate }}</div>
                                                        <div class="t-h" *ngIf="state.config.c.reports.separatePeerAndSubordinate" [innerHtml]="'REPORT.COLLEAGUES_PEERS' | translate"></div>
                                                        <div class="t-h" *ngIf="state.config.c.reports.separatePeerAndSubordinate && data.isBoss">{{ 'REPORT.SUBORDINATES' | translate }}</div>
                                                        <div class="t-h" >{{ 'REPORT.INDIVIDUAL_AVERAGE' | translate }}</div>
                                                        <div class="t-h" *ngIf="isRpClosed(data.reviewPeriod)">{{ 'REPORT.COMPANY_AVERAGE' | translate }}</div>
                                                    </div>
                                                </mat-card-header>
            
                                                <mat-card-content *ngIf="questionGroup.questions.length > 0">
                                                    <!-- question group: questions -->
                                                    <div class="t-row" *ngFor="let question of questionGroup.questions; let questionIndex = index">
                                                        <div class="t-d mobile-flex-full flex-horizontal qname">
                                                            <div class="q-index text-left">{{ question.index }}</div><div class="text-left">{{ question.name}}</div>
                                                            <div class="weight-icon">
                                                                <app-weight-indicator *ngIf="question.weight" [weight]="question.weight" [size]="30"></app-weight-indicator>
                                                            </div>
                                                        </div>
                                                        <div class="t-d colored-field" [ngStyle]="{ 'background-color': question.ownRating.color }">{{ question.ownRating.value | number:'1.0-0' | nozero }}</div>                    
                                                        <div class="t-d colored-field" [ngStyle]="{ 'background-color': question.leaderRatings[0].color }">{{ question.leaderRatings[0].value | number:'1.0-0' | nozero }}</div>
                                                        <div class="t-d colored-field" *ngIf="data.leaders[1]" [ngStyle]="{ 'background-color': question.leaderRatings[1].color }">{{ question.leaderRatings[1].value | number:'1.0-0' | nozero }}</div>
                            
                                                        <div class="t-d colored-field" *ngIf="!state.config.c.reports.separatePeerAndSubordinate" [ngStyle]="{ 'background-color': question.fullRating.color }">{{ question.isDeviationLarge ? '*' : ''}} {{ question.fullRating.value | number:'1.1-1' | nozero }}</div>
                                                        <div class="t-d colored-field" *ngIf="state.config.c.reports.separatePeerAndSubordinate" [ngStyle]="{ 'background-color': question.peerRating.color }">{{ question.isPeerDeviationLarge ? '*' : ''}} {{ question.peerRating.value | number:'1.1-1' | nozero }}</div>
                                                        <div class="t-d colored-field" *ngIf="state.config.c.reports.separatePeerAndSubordinate && data.isBoss" [ngStyle]="{ 'background-color': question.subordinateRating.color }">{{ question.isSubordinateDeviationLarge ? '*' : ''}} {{ question.subordinateRating.value | number:'1.1-1' | nozero }}</div>
                                                        <div class="t-d">{{ question.ratingAverage | number:'1.1-1' | nozero }}</div>
                                                        <div class="t-d" *ngIf="isRpClosed(data.reviewPeriod)">{{ question.companyRatingAverage | number:'1.1-1' | nozero }}</div>
                                                    </div>
                                                </mat-card-content>
        
                                                <mat-card-footer *ngIf="questionGroup.questions.length > 0" class="break-inside-avoid">
                                                    <!-- question group: sum -->
                                                    <div class="t-row font-semibold">
                                                        <div class="t-d mobile-flex-full flex-horizontal gap-1.5" [attr.colspan]="getColumnCount(data.leaders.length)">
                                                            <div class="q-index text-left"></div><div class="text-left">{{ questionGroup.isWeighted ? ('REPORT.QUESTION_GROUP_WEIGHTED_AVERAGE' | translate) : ('REPORT.QUESTION_GROUP_AVERAGE' | translate) }}</div>
                                                        </div>
        
                                                        <div class="t-d">{{ questionGroup.overall.ownRating.value | number:'1.1-1' | nozero }}</div>
                                                        <div class="t-d">{{ questionGroup.overall.leaderRatings[0].value | number:'1.1-1' | nozero }}</div>
                                                        <div class="t-d" *ngIf="data.leaders[1]">{{ questionGroup.overall.leaderRatings[1].value | number:'1.1-1' | nozero }}</div>
                            
                                                        <div class="t-d" *ngIf="!state.config.c.reports.separatePeerAndSubordinate">{{ questionGroup.overall.fullRating.value | number:'1.1-1' | nozero }}</div>
                                                        <div class="t-d" *ngIf="state.config.c.reports.separatePeerAndSubordinate">{{ questionGroup.overall.peerRating.value | number:'1.1-1' | nozero }}</div>
                                                        <div class="t-d" *ngIf="state.config.c.reports.separatePeerAndSubordinate && data.isBoss">{{ questionGroup.overall.subordinateRating.value | number:'1.1-1' | nozero }}</div>
                                                        <div class="t-d"></div>
                                                        <div class="t-d" *ngIf="isRpClosed(data.reviewPeriod)"></div>
                                                    </div>
                                                </mat-card-footer>
                                            </mat-card>
                                        </div>

    
                                        <!-- module sum -->
                                        <mat-card class="card-table break-inside-avoid no-bottom-padding">
                                            <mat-card-footer>
                                                <div class="t-row sum-row">
                                                    <div class="t-d mobile-flex-full flex-horizontal q-group-name">
                                                        <div class="q-index text-left"></div><div>{{ 'REPORT.OVERALL_RESULT' | translate }}</div>
                                                    </div>
                                                    <div class="t-d"><strong>{{ module.overall.ownRating.value | number:'1.1-1' | nozero }}</strong></div>
                            
                                                    <div class="t-d"><strong>{{ module.overall.leaderRatings[0].value | number:'1.1-1' | nozero }}</strong></div>
                                                    <div class="t-d" *ngIf="data.leaders[1]"><strong>{{ module.overall.leaderRatings[1].value | number:'1.1-1' | nozero }}</strong></div>
                            
                                                    <div class="t-d" *ngIf="!state.config.c.reports.separatePeerAndSubordinate"><strong>{{ module.overall.fullRating.value | number:'1.1-1' | nozero }}</strong></div>
                                                    <div class="t-d" *ngIf="state.config.c.reports.separatePeerAndSubordinate"><strong>{{ module.overall.peerRating.value | number:'1.1-1' | nozero }}</strong></div>
                                                    <div class="t-d" *ngIf="state.config.c.reports.separatePeerAndSubordinate && data.isBoss"><strong>{{ module.overall.subordinateRating.value | number:'1.1-1' | nozero }}</strong></div>
                                                    <div class="t-d"><strong>{{ module.overall.ratingAverage | number:'1.1-1' | nozero }}</strong></div>
                                                    <div class="t-d" *ngIf="isRpClosed(data.reviewPeriod)"><strong>{{ module.overall.companyRatingAverage | number:'1.1-1' | nozero }}</strong></div>
                                                </div>
                                            </mat-card-footer>
                                        </mat-card>
    
                                    </div>
                                </div>
                        </div>
                    </ng-container>
                </ng-container>
    
                <div class="row break-inside-avoid legend-block">
                    <mat-card class="full-width">
                        <mat-card-content>
                            <div class="legend-text">
                                <p>
                                    <strong>{{ 'REPORT.ASTERISK_MARKS' | translate }}</strong> {{ 'REPORT.ASTERISK_DESCRIPTION' | translate }}<br>
                                </p>
                                <p>
                                    <strong>{{ 'REPORT.INDIVIDUAL_AVERAGE_DESC' | translate }}</strong> {{ 'REPORT.INDIVIDUAL_AVERAGE_EXPLANATION' | translate }}<br>
                                </p>
                                <p>
                                    <strong>{{ 'REPORT.COMPANY_AVERAGE_DESC' | translate }}</strong> {{ 'REPORT.COMPANY_AVERAGE_EXPLANATION' | translate }}
                                </p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
                    
                <!-- kpi -->
                <!-- <div class="row" *ngIf="hasItems(data.keyPerformanceIndicators)">            
                    <table class="separator">
                        <caption><h4>KULCS MUTATÓK, TERVSZÁMOK (KPI)</h4></caption>
                        <div class="t-head"ead>
                            <div class="t-row">
                                <div class="t-head"></div>
                                <div class="t-head">mértékegység</div>
                                <div class="t-head">terv</div>
                                <div class="t-head">teljesült</div>
                                <div class="t-head">teljesítmény</div>
                            </div>
                        </divead>
                        <tbody>
                            <tr *ngFor="let kpi of data.keyPerformanceIndicators">
                                <td>{{kpi.kpiType.name}}</div>
                                <td>{{kpi.kpiType.unit}}</div>
                                <td>{{kpi.planned | number:'1.1-1' | nozero }}</div>
                                <td>{{kpi.achieved | number:'1.1-1' | nozero }}</div>
                                <td>{{(100 * kpi.achieved/kpi.planned) | number:'1.1-1' }}%</div>
                            </div>
                            <div class="t-row">
                                <td><strong>Kulcs mutatók, tervszámok (KPI) összesített teljesítmény</strong></div>
                                <td></div>
                                <td></div>
                                <td></div>
                                <td><strong>{{ data.kpiOverallPercent | number:'1.1-1' }}%</strong></div>
                            </div>
                        </tbody>                    
                    </table>            
                </div> -->
            
                <div class="row" *ngIf="hasItems(data.freeTexts)">
                    
                    <mat-card class="full-width">
                        <mat-card-content>
                            <!-- freeText -->
                            <app-freetext-panel [freeTexts]="data.freeTexts" [noMargin]="true" [questionMode]="true" [questionComments]="questionComments"></app-freetext-panel>
                            
                        </mat-card-content>
                    </mat-card>
                </div>
                          
    
            </div>
        </ng-container>
    
    </app-report-frame>

</div>
